module.exports = __webpack_public_path__ + "images/underweight.f51f24f6f841ae3562e729055fc2cf99.png";